/**
 * Invoke a Supabase Edge Function asynchronously (fire-and-forget)
 * This function returns immediately without waiting for the Edge Function to complete
 */
export function invokeEdgeFunctionAsync(
  supabaseUrl: string,
  functionName: string,
  body: any,
  token: string // Can be either user JWT token or service role key
): void {
  // Use native fetch without waiting for response
  // keepalive ensures the request continues even if the process ends
  fetch(`${supabaseUrl}/functions/v1/${functionName}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      'x-client-info': 'supabase-js-web/2.50.3', // Add client info header
    },
    body: JSON.stringify(body),
    // Important: keepalive allows request to continue even after response is sent
    keepalive: true,
  }).catch((error) => {
    // Log error but don't throw - this is fire-and-forget
    console.error(`Failed to invoke ${functionName} Edge Function:`, error);
  });
  
  // Return immediately without waiting
}